module.exports = __webpack_public_path__ + "static/media/data-managments.48e1766b.png";